import React from 'react';

import { Paper, Grid, Typography, Box } from '@material-ui/core';

import { useStyles } from './styles/introCardStyles';

import { renderSvg } from '../../General/AnimatedSvgs/renderSvg';

export const IntroCard = ({ card }) => {
  const classes = useStyles();

  const { icon, header, description } = card;
  return (
    <Grid item xs={12} md={4} className={classes.gridItem}>
      <Paper className={classes.box}>
        <Box className={classes.iconWrapper}>{renderSvg(icon)}</Box>
        <Typography variant='h3' className={classes.boxH3}>
          {header}
        </Typography>

        <Typography variant='body1' className={classes.boxP}>
          {description}
        </Typography>
      </Paper>
    </Grid>
  );
};
